/*******************************************************
 * COHERENCE SERVICE
 *
 * Gestion de l'interface des scripts de cohérence
 *******************************************************/

"use strict";


angular.module("coherence", []) // Initialisation du module ici, puisque seul service du module.
	.factory("CoherenceService", ["ENV", "$http", function (ENV, $http) {

		const DOMAIN_TYPE = {
			SCHOOL_ITI: "SCHOOL_ITI",
			E_ITI: "E_ITI"
		};

		const resource = "/coherence";

		// PUBLIC API
		return {
			DOMAIN_TYPE: DOMAIN_TYPE,


			getCoherenceList: getCoherenceList,
			getCoherenceDetail: getCoherenceDetail,
			loadDetailResults: loadDetailResults,
			refreshCoherenceView: refreshCoherenceView,
		};

		/**
		 * Récupère la liste des scripts de cohérence
		 * @returns {HttpPromise}
		 */
		function getCoherenceList(domainType) {
			return $http.get(ENV.API_URL + resource + "?domain-type=" + domainType);
		}

		/**
		 * Retourne le détail d'une vue de cohérence
		 * @param id
		 * @returns {HttpPromise}
		 */
		function getCoherenceDetail(id) {
			return $http.get(ENV.API_URL + resource + "/" + id);
		}

		/**
		 * Charge la liste des résultats de la vue de cohérence
		 * @param id
		 * @returns {HttpPromise}
		 */
		function loadDetailResults(id) {
			return $http.get(ENV.API_URL + resource + "/" + id + "/results");
		}

		/**
		 * Recharge une vue, traitement très long.
		 * @param id
		 * @returns {HttpPromise}
		 */
		function refreshCoherenceView(id) {
			return $http.post(ENV.API_URL + resource + "/" + id + "/refresh");
		}
	}]);
